module.exports = __webpack_public_path__ + "static/media/EmptyState_CaseStudies.a6edbd3a.png";